import {
  INTEGRATIONS_FETCHED,
  INTEGRATION_FETCHED,
  INTEGRATION_DELETED,
} from 'constants/actions';

const initialState = [];

export default function company(state = initialState, action) {
  switch (action.type) {
    case INTEGRATIONS_FETCHED:
      return [...action.integrations];
    case INTEGRATION_FETCHED:
      return [
        ...state.filter((integration) => {
          return integration.id !== action.integration.id;
        }),
        action.integration,
      ];
    case INTEGRATION_DELETED:
      return state.filter((integration) => {
        return integration.id !== action.integrationId;
      });
    default:
      return state;
  }
}
